import React, { useState } from "react";
import { api } from "../swof/api";
import { AdminShell } from "./ProtectedRoute";
import {
  knopStijl, wegStijl, invoerStijl, Foutmelding, Titel, Uploader, useAdminContent, mediaKaart,
  Sleeplijst,
} from "./bouwstenen";

function Logo({ media, hoogte }) {
  return (
    <div style={{
      width: 150, height: 72, background: "#1a1611", border: "1px solid var(--line)",
      display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, padding: 8,
    }}>
      {media ? (
        <img src={media.varianten?.["400"] || media.url} alt={media.alt || ""}
          style={{ maxHeight: Math.min(hoogte || 56, 56), maxWidth: "100%", objectFit: "contain" }} />
      ) : (
        <span style={{ fontFamily: "var(--mono)", fontSize: 8, color: "rgba(243,234,215,0.35)" }}>geen logo</span>
      )}
    </div>
  );
}

export default function PartnersPage() {
  const { content, herlaad, fout, melden } = useAdminContent();
  const [naam, setNaam] = useState("");
  const [bezig, setBezig] = useState(false);
  const media = mediaKaart(content?.media);

  const doe = async (fn) => {
    setBezig(true);
    try { await fn(); await herlaad(); } catch (e) { melden(e); } finally { setBezig(false); }
  };

  const toevoegen = (e) => {
    e.preventDefault();
    doe(async () => {
      await api.post("/admin/partners", { velden: { naam, hoogte: 56, inkleuren: false, link: "" } });
      setNaam("");
    });
  };
  const wijzig = (p, velden) => doe(() => api.put(`/admin/partners/${p.id}`, { velden }));
  const verwijder = (p) => {
    if (!window.confirm(`${p.naam} verwijderen als partner?`)) return;
    doe(() => api.delete(`/admin/partners/${p.id}`));
  };
  const herorden = (items) => doe(() => api.post("/admin/partners/reorder", { order: items.map((i) => i.id) }));

  return (
    <AdminShell title="Partners">
      <Titel onder="Logo's in het partnerblok. Wijzigingen komen in het concept; publiceer het blok Partners om ze live te zetten.">Partners</Titel>
      <Foutmelding fout={fout} testId="partners-fout" />

      <form onSubmit={toevoegen} style={{ display: "flex", gap: 12, alignItems: "end", marginBottom: 32, flexWrap: "wrap" }}>
        <input value={naam} onChange={(e) => setNaam(e.target.value)} required placeholder="Naam van de partner"
          data-testid="partner-naam" style={{ ...invoerStijl, maxWidth: 360 }} />
        <button type="submit" disabled={bezig} data-testid="partner-toevoegen" style={{
          ...knopStijl, background: "var(--gold)", color: "var(--ink)", border: "none", padding: "13px 20px",
        }}>Toevoegen</button>
      </form>

      {!content ? <div style={{ opacity: 0.5 }}>Laden…</div> : (
        <Sleeplijst items={content.partners} onOrde={herorden} testId="partner-lijst" render={(p) => (
          <div data-testid={`partner-${p.id}`} style={{ display: "flex", gap: 18, alignItems: "center", flex: 1, flexWrap: "wrap" }}>
            <Logo media={media[p.logo_id]} hoogte={p.hoogte} />
            <div style={{ flex: "1 1 260px", display: "grid", gap: 8 }}>
              <input defaultValue={p.naam} data-testid={`partner-naam-${p.id}`}
                onBlur={(e) => e.target.value !== p.naam && wijzig(p, { naam: e.target.value })}
                style={{ ...invoerStijl, padding: "8px 10px", fontSize: 15 }} />
              <input defaultValue={p.link || ""} placeholder="Website (optioneel, https://…)"
                data-testid={`partner-link-${p.id}`}
                onBlur={(e) => e.target.value !== (p.link || "") && wijzig(p, { link: e.target.value })}
                style={{ ...invoerStijl, padding: "8px 10px", fontSize: 13 }} />
            </div>
            <div style={{ display: "grid", gap: 8 }}>
              <select value={p.logo_id || ""} data-testid={`partner-logo-${p.id}`}
                onChange={(e) => wijzig(p, { logo_id: e.target.value || null })}
                style={{ ...invoerStijl, padding: "8px 10px", fontSize: 13, maxWidth: 260 }}>
                <option value="" style={{ color: "#111" }}>— geen logo —</option>
                {content.media.map((m) => (
                  <option key={m.id} value={m.id} style={{ color: "#111" }}>{m.bestandsnaam}</option>
                ))}
              </select>
              <Uploader testId={`partner-upload-${p.id}`} label="Logo uploaden" meerdere={false} soort="logo"
                onKlaar={(nieuw) => wijzig(p, { logo_id: nieuw[0].id })} />
            </div>
            <label style={{ fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.14em", textTransform: "uppercase", opacity: 0.8 }}>
              Hoogte<br />
              <input type="number" min={24} max={200} defaultValue={p.hoogte} data-testid={`partner-hoogte-${p.id}`}
                onBlur={(e) => Number(e.target.value) !== p.hoogte && wijzig(p, { hoogte: Number(e.target.value) })}
                style={{ ...invoerStijl, width: 80, padding: "6px 8px", fontSize: 13, marginTop: 4 }} />
            </label>
            <label style={{ fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.14em", textTransform: "uppercase", opacity: 0.8, display: "flex", gap: 6, alignItems: "center" }}>
              <input type="checkbox" checked={!!p.inkleuren} data-testid={`partner-inkleuren-${p.id}`}
                onChange={(e) => wijzig(p, { inkleuren: e.target.checked })} />
              Goudtint
            </label>
            <button onClick={() => verwijder(p)} disabled={bezig} data-testid={`partner-weg-${p.id}`} style={wegStijl}>Weg</button>
          </div>
        )} />
      )}
    </AdminShell>
  );
}
